import { z } from "zod";
import { distributionCardSchema } from "../../../../../schemas/distributionCardSchema";
import { getAICardBaseDetails } from "../../utils/getAICardBaseDetails";
import { NodeOutputData, NodeType } from "common/src/modules/nodes/nodes.types";
import { NO_NODE_ID } from "common/src/components/CLCardsMap/CLCardsMap.config";
import { DTDistributionNode } from "common/src/modules/decisionTree/decisionTree.types";

export const convertDistributionAICardToAPICard = (distributionCard: z.input<typeof distributionCardSchema>, existingCard: DTDistributionNode | undefined) => {

  const outputs = distributionCard.outputs.map((output, index) => ({
    nodeId: existingCard?.outputs?.[index]?.nodeId ?? NO_NODE_ID,
    id: index + 1,
    name: output.name ?? `Output ${index + 1}`,
  })) as NodeOutputData[];
  
  return {
    ...getAICardBaseDetails(distributionCard),
    type: NodeType.DISTRIBUTION,
    description: distributionCard.description,
    outputs: outputs,
    inputs: [],
  } as DTDistributionNode;
}